import template from './view.html'

export default function treeSelectDirective(logger, $timeout, httpRequest, $uibModal) {
    return {
        restrict: 'EA',
        scope: {
            selectorglist: '=',
            queryJson: '=',
        },
        template,
        link(scope) {
            scope.collapse = function (e) {
                const $collapseBtn = $(e.target)
                const $collapseTop = $collapseBtn.parent().parent('.orgtree-top')
                $collapseTop.next('.orgtree-content').slideToggle('fast')
            }
            scope.onSelect = function (item) {
                scope.$emit('on-org-select', item)
            }
        },
    }
}
treeSelectDirective.$inject = ['logger', '$timeout', 'httpRequest', '$uibModal']



// WEBPACK FOOTER //
// ./src/components/treeSelect/treeSelectDirective.js